"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButtonStyled = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var IconButtonStyled = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t", "\n\t", "\n\t", "\n\t", "\n\t", "\n\t", "\n\tfont-weight: 500;\n\tcursor: pointer;\n\tdisplay: flex;\n\talign-items: center;\n\tborder-radius: ", ";\n\tborder: none;\n\tbackground: transparent;\n\tposition: relative;\n\t&::before {\n\t\tposition: absolute;\n\t\tleft: 80%;\n\t\ttop: -30%;\n\t\tfont-size: 10px;\n\t\topacity: 0.5;\n\t\tmin-width: 48px;\n\t}\n\t&:hover {\n\t\t&::before {\n\t\t\tcontent: ", ";\n\t\t}\n\t}\n"])), _styledSystem.typography, (0, _styledSystem.variant)({
  scale: 'textButtonColors',
  prop: 'color'
}), _styledSystem.layout, _styledSystem.space, _styledSystem.flexbox, _styledSystem.textAlign, function (props) {
  return "".concat(props.theme.borderRadii.large, "px");
}, function (props) {
  return "\"".concat(props.tooltip, "\"");
});
exports.IconButtonStyled = IconButtonStyled;